import React, { useRef } from 'react'
import { getZendeskLinkAndToken } from 'src/hooks/zendesk/api/getZendeskUrl'
import { useTranslation } from 'react-i18next'
import {
  CardImage,
  CardSubtitle,
  CardTitle,
  Cards,
} from 'Components/Elements/HelpCenterModal/HelpCenterModal.styled'
import { HelpCenterIcon } from 'Assets/icons/HelpCenterIcon'
import { useUserStore } from 'Stores/userStoreModuleFed'

interface HelpCenterCardProps {
  key: number
}

export const HelpCenterCard = ({ key }: HelpCenterCardProps) => {
  const { t } = useTranslation('helpCenterModal')

  const { userId } = useUserStore()

  const formRef = useRef<HTMLFormElement>(null)
  const jwtInputRef = useRef<HTMLInputElement>(null)
  const returnToInputRef = useRef<HTMLInputElement>(null)

  const handleClick = () => {
    getZendeskLinkAndToken(userId)
      .then((response) => {
        if (!(response instanceof Error) && response?.data) {
          if (jwtInputRef?.current && formRef) {
            jwtInputRef.current.value = response.data.jwt
          }

          if (returnToInputRef?.current && formRef) {
            returnToInputRef.current.value = response.data.return_to
          }

          if (formRef.current) {
            formRef.current.action = response.data.jwt_req_url
            formRef.current.submit()
          }
        }
      })
      .catch((err: Error) => console.error(err))
  }

  return (
    <Cards key={key} onClick={handleClick}>
      <CardImage>
        <HelpCenterIcon />
      </CardImage>
      <CardTitle>{t('cards.help_center.title')}</CardTitle>
      <CardSubtitle>{t('cards.help_center.subtitle')}</CardSubtitle>
      <form ref={formRef} method="post" style={{ display: 'none' }}>
        <input ref={jwtInputRef} type="hidden" name="jwt"></input>
        <input ref={returnToInputRef} type="hidden" name="return_to"></input>
      </form>
    </Cards>
  )
}
